// extracted by mini-css-extract-plugin
module.exports = {"block":"_14961","title":"_16009","content":"_4624","more":"_876","arrow":"_14992","store":"_183","guide":"_346"};